import { render, staticRenderFns } from "./EditMedia.vue?vue&type=template&id=4068cea8&scoped=true&"
import script from "./EditMedia.vue?vue&type=script&lang=js&"
export * from "./EditMedia.vue?vue&type=script&lang=js&"
import style0 from "./EditMedia.vue?vue&type=style&index=0&id=4068cea8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4068cea8",
  null
  
)

export default component.exports